import Vue from 'vue'
import VueRouter from 'vue-router'
import Parse from 'parse'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/Login.vue'),
  },
  /*{
    path: '/orders',
    name: 'orders',
    alias: '/admin',
    component: () => import('../views/Admin.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'Operador'] }
  },*/
  {
    path: '/stores',
    name: 'stores',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Stores.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'Operador'] }
  },
  {
    path: '/tomahawk/:store_id',
    name: 'tomahawk',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Tomahawk.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'Operador'] }
  },
  {
    path: '/orders-delivered/:store_id',
    name: 'ordersDelivered',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/OrdersDelivered.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'support'] }
  },
  {
    path: '/mystore/:store_id',
    name: 'mystore',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/MyStore.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'Operador'] }
  },
  {
    path: '/mystore/mobile/:store_id',
    name: 'mystoreMobileVersion',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/MyStoreMobileVersion.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'Operador'] }
  },
  {
    path: '/mystore-invoices/:store_id',
    name: 'mystoreInvoices',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/MyStoreInvoices.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'Operador'] }
  },
  {
    path: '/me/:store_id',
    name: 'profile',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Profile.vue'),
    meta: { requiresAuth: false, role: [] }
  },
  {
    path: '/mystore/:store_id/:token',
    name: 'mystoretoken',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/MyStoreToken.vue'),
    meta: { requiresAuth: false, role: [] }
  },
  {
    path: '/mystore/:store_id/:token/:report',
    name: 'mystoretokenreport',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/MyStoreToken.vue'),
    meta: { requiresAuth: false, role: [] }
  },
  {
    path: '/mobile/config/schedule/:store_id/:token',
    name: 'mystoreschedule',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/MyStoreTokenMobile.vue'),
    meta: { requiresAuth: false, role: [] }
  },
  {
    path: '/invoice/:invoice_id/:store_id',
    name: 'invoice',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/InvoicePrint.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'Operador'] }
  },
  {
    path: '/customers/:store_id',
    name: 'customers',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Customers.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'support'] }
  },
  {
    path: '/products/:store_id',
    name: 'products',
    component: () => import('../views/Products.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'support'] }
  },
  {
    path: '/reports/:store_id',
    name: 'ReportMyStore',
    component: () => import('../views/ReportMyStore.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'support'] }
  },
  /*{
    path: '/printers/:store_id',
    name: 'MyPrinters',
    component: () => import('../views/Printer.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'support'] }
  },*/
  {
    path: '/config/schedule/:store_id',
    name: 'schedule',
    component: () => import('../views/WeekDaysConfig.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'support'] }
  },
  {
    path: '/mobile/config/schedule/:store_id',
    name: 'scheduleMobile',
    component: () => import('../views/WeekDaysConfigMobile.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'support'] }
  },
  {
    path: '/epco/response',
    name: 'ePaycoInvoice',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ePaycoResponse.vue'),
    meta: { requiresAuth: false, role: ['Administrador', 'Operador'] }
  },
  {
    path: '/categories/:store_id',
    name: 'categories',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ProductCategories.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'support'] }
  },
  {
    path: '/riders/:store_id',
    name: 'riders',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Riders.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'support'] }
  },
  {
    path: '/banners/:store_id',
    name: 'banners',
    component: () => import('../views/BannersStore.vue'),
    meta: { requiresAuth: true, role: ['Administrador', 'support'] }
   },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach( async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const loggedIn = Parse.User.current();
  const roles_array = to.meta.role;

  if (requiresAuth && !loggedIn) {
    return next('/');
  }

  if (roles_array) {
    /*const isRoleUser = await isRole(roles_array);
    //console.log(roles_array);
    //console.log(isRoleUser);
    if(!isRoleUser){
      alert('No tienes los permisos suficientes. ' + roles_array.join(', '))
      return next('/');
    }*/

  }
  next();
})

//eslint-disable-next-line
const isRole = async roles_array => {
  const query = new Parse.Query(Parse.Role)
  query.equalTo('users', Parse.User.current())
  try {
    const roles = await query.find();
    if (roles && roles_array.length > 0) {
      for (let index = 0; index < roles.length; index++) {
        for (let i = 0; i < roles_array.length; i++) {
          if (roles[index].attributes.name === roles_array[i]) {
            return true;
          }
          
        }
      }
      return false;
    }else{
      return false;
    }
  } catch (error) {
    return error.message
  }
};

export default router
